import { render, staticRenderFns } from "./Scopes.vue?vue&type=template&id=d3c95c50&scoped=true"
import script from "./Scopes.vue?vue&type=script&lang=ts"
export * from "./Scopes.vue?vue&type=script&lang=ts"
import style0 from "./Scopes.vue?vue&type=style&index=0&id=d3c95c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c95c50",
  null
  
)

export default component.exports